/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_Status_PendingInputs */

const vi_snapshot_status_pending = /** @type {(inputs: Snapshot_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ duyệt`)
};

/**

* @param {Snapshot_Status_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const snapshot_status_pending = /** @type {((inputs?: Snapshot_Status_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_Status_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_snapshot_status_pending(inputs)
});